import React from 'react'
import {getFullAddress, NullAsDefault, renderIfElse} from 'views/Shared'
import {renderIf} from "../../../Shared";
import _ from "lodash"
import CRUD from "../../../Shared/enums/CRUD";
import {ROOT_URL} from "../../../../envs/_current/config";
import {BiSolidChurch} from "react-icons/bi";
import {Avatar, message} from "antd";
import {useChurches} from "../../Church/functions/useChurches";
import copyToClipboard from "copy-to-clipboard";
import {HiQrCode} from "react-icons/hi2";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";

export const renderEventLocationItem = ({event, translate: t, isLg, lookupParams = {}, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const {address, church, parish, diocese, description} = item ?? {}
    const {churchModal, showDialog} = useChurches({
        notifyListeners: {}
    })

    return (
        <div className="flex gap-3 rounded-lg custom-item-render render-border-center hover:shadow relative">
            <Avatar
                size={120}
                className="flex flex-center background-200 rounded-l-lg rounded-r-0 cursor-pointer"
                src={church?.photo}
                icon={<BiSolidChurch size={60} className="text-color-500"/>}
            />
            <div className="py-2 flex flex-col flex-1 gap-1">
                <div
                    onClick={() => {
                        if (church) {
                            showDialog(church)
                        } else {
                            handleAction(CRUD.READ, item)
                        }
                    }}
                    className="mr-4 font-bold text-base text-color-000 hover:text-primary max-lines-2 leading-tight cursor-pointer">
                    {item?.name}
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex flex-col">
                        {renderIfElse(
                            church,
                            <ItemInformation label="address" value={getFullAddress(church)} className="text-xs" />,
                            <ItemInformation label="address" value={address} className="text-xs" />
                        )}
                        {renderIfElse(
                            church,
                            <DoubleValueItem
                                labelFirst="belong to parish"
                                valueFirst={church?.parish_name}
                                labelSecond={church?.diocese_name && " - " || ''}
                                valueSecond={church?.diocese?.fullname}
                                className="text-xs italic"
                            />,
                            <DoubleValueItem
                                labelFirst="belong to parish"
                                valueFirst={parish?.name}
                                labelSecond={diocese?.fullname && " - " || ''}
                                valueSecond={diocese?.fullname}
                                className="text-xs italic"
                            />
                        )}
                    </div>
                    <div className="text-xs text-color-300 max-lines-1">
                        {description}
                    </div>
                    <div className="flex-1"/>
                    <div
                        onClick={() => {
                            copyToClipboard(`${ROOT_URL}/event-checkin/${event?.id}/${item?.idname}/invites`)
                            message.success(t('copied'))
                        }}
                        style={{ padding: '4px 10px', height: 26, fontSize: 12, borderRadius: '0.35rem' }}
                        className="w-fit flex items-center gap-2 bg-blue-100 hover:bg-blue-200 text-blue-600 font-medium italic cursor-pointer">
                        {t('copy qr code')}
                        <HiQrCode size={16}/>
                    </div>
                </div>
                <div className="absolute bottom-10 right-10">
                    <div
                        onClick={() => {
                            if (church) {
                                showDialog(church)
                            } else {
                                handleAction(CRUD.READ, item)
                            }
                        }}
                        className="text-xs text-color-500 hover:text-color-100 italic tracking-wide cursor-pointer">
                        {`${t('view detail')}...`}
                    </div>
                </div>
            </div>
            {renderIf(
                _.isFunction(renderContextMenu),
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
            {churchModal}
        </div>
    )
}

